import { Component, EventEmitter, OnDestroy, OnInit, Output, Type } from '@angular/core';
import { BaseSectionEditorDirective } from '../base-section-editor.directive';
import { SectionEditorBridgeService } from '../../../services/section-editor-bridge.service';
import { NbDialogService } from '@nebular/theme';
import { PreviewEditStoreService } from '../../../services/preview-edit-store.service';
import { IframeCommunicationService } from '../../../services/iframe-communication.service';
import { GridCell, RowCell } from '@urbannex/storethemes';
import { EditorDialogComponent } from '../../dialogs/editor-dialog/editor-dialog.component';

@Component({
  selector: 'kve-bloglist-editor',
  templateUrl: './bloglist-editor.component.html',
  styleUrls: ['./bloglist-editor.component.scss']
})
export class BloglistEditorComponent extends BaseSectionEditorDirective implements OnInit, OnDestroy {
  rowCells: GridCell[];
  cellId: string;
  selectedCell: GridCell | RowCell;

  @Output() setListMode = new EventEmitter();

  constructor(sectionEditorBridge: SectionEditorBridgeService,
    private dialogService: NbDialogService,
    previewEditStoreService: PreviewEditStoreService,
    private communicator: IframeCommunicationService,
  ) {
    super(sectionEditorBridge, previewEditStoreService)
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.rowCells = this.selectedSection.sectionData["blogListOptions"].rowCells;
  }

  open(options: any) {
    this.cellId = options["cellId"];
    this.resolveSelectedCell(this.cellId);
    const action = options["action"];
    const imgSrc = options["imgSrc"];
    this.previewEditStoreService.selectedCell$.subscribe(_selectedCell => { })
    const component: Type<any> = EditorDialogComponent;
    const title = "Title"
    const dialogRef = this.dialogService.open(component, {
      context: {
        title: title,
        imgSrc: imgSrc,
        cellId: this.cellId,
        section: this.selectedSection,
        selectedCell: this.selectedCell,
        dialogWidth: 960
      },
    })

    dialogRef.onClose.subscribe((resp: GridCell | RowCell) => {
      if (resp != undefined) {
        this.previewEditStoreService.updateSelectedCell(resp)
      }
    })
  }

  goBack(e) {
    this.setListMode.emit();
  }

  resolveSelectedCell(cellId) {
    console.log(this.selectedSection)
    const cells: GridCell[] = this.selectedSection.sectionData.blogListOptions.rowCells;
    if (cells != undefined && cells.length > 0) {
      this.selectedCell = cells.find(cell => cell.cellId == cellId);
      console.log(this.selectedCell);
      console.log(cellId);
      this.communicator.sendFromParent({ id: "cellLayout", data: { elId: this.selectedRenderedSection.elementId, section: this.selectedSection, cellId: cellId } });

    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
